// Storage-key candidates for a chapter's audio, mirroring AudioPlayer.js:
// the chapter's own key first, then the conventional path with each extension.
const AUDIO_FILE_EXTENSIONS = ['mp3', 'm4a', 'wav', 'aac', 'ogg', 'flac'];
const PUBLIC_CATALOG_PREFIXES = ['curated/', 'scientific_papers/', 'graphic/', 'classics/', 'short_stories/', 'explainers/'];

const looksLikeStorageKey = (value) => {
  const key = String(value || '').trim();
  if (!key || /^https?:\/\//i.test(key) || key.startsWith('blob:')) return false;
  return key.startsWith('users/') || PUBLIC_CATALOG_PREFIXES.some((p) => key.startsWith(p));
};

export function bookKeyFor(bookId, isCurated) {
  return `${isCurated ? 'c' : 'u'}:${bookId}`;
}

export function chapterAudioKeyCandidates(book, chapter, userId) {
  const chapterId = String(chapter?.id ?? '1');
  const catalogRoot = String(book?.catalogRoot || '').trim().replace(/\/+$/, '') || 'curated';
  const sourceId = String(book?.sourceAudiobookId || book?.id || '');
  const base = book?.isCurated
    ? `${catalogRoot}/audiobooks/${sourceId}/audio/${chapterId}`
    : `users/${userId}/audiobooks/${book?.id}/audio/${chapterId}`;
  const own = [chapter?.audioUrl, chapter?.audio_url, chapter?.audioKey, chapter?.audio_key]
    .map((v) => String(v || '').trim())
    .filter(looksLikeStorageKey);
  const conventional = AUDIO_FILE_EXTENSIONS.map((ext) => `${base}.${ext}`);
  return Array.from(new Set([...own, ...conventional]));
}
